import { useEffect, useState, useCallback } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";
import { BACKEND_URL } from "@/constants/api";

/**
 * Returns the active school memberships for the signed-in user.
 * Each entry: { _id, school: { _id, name, sharingMode, adminId }, status, isAdmin }
 */
export default function useMySchools() {
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { getToken } = useAuth();
  const { isSignedIn, isLoaded } = useUser();

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const token = await getToken();
      const res = await fetch(`${BACKEND_URL}api/schools`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch schools");
      setMemberships(await res.json());
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => {
    if (isSignedIn && isLoaded) refetch();
  }, [isSignedIn, isLoaded, refetch]);

  return { memberships, loading, error, refetch };
}
